import React, { useEffect } from 'react';
import NotificationForm from '/b2b/account/routes/Account/components/NotificationForm';
import PropTypes from 'prop-types';

const AccountNotifications = props => {
    const { onInitialLoad, onUpdateUserNotifications, userId, values } = props;

    useEffect(() => {
        userId && onInitialLoad(userId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId]);

    return <NotificationForm {...props} onSubmit={onUpdateUserNotifications} values={values} />;
};

AccountNotifications.propTypes = {
    onInitialLoad: PropTypes.func,
    onUpdateUserNotifications: PropTypes.func,
    userId: PropTypes.string,
    values: PropTypes.object,
};

export default AccountNotifications;
